<template>
    <div class="l-row">
        <div class="l-row__column">
            <div class="o-dashboardSummary a-mobile">
                <div
                    v-if="lastInvoiceStatus === 'empty' && nextDeliveryStatus === 'empty'"
                    class="l-row__column--8 o-dashboardSummary__panel o-dashboardSummary__panel--left"
                >
                    <p class="a-title">
                        Brak zamówień
                    </p>
                    <p class="a-text">
                        Nie masz jeszcze żadnego zamówienia. Złóż nowe zamówienie lub skontaktuj się z Biurem Obsługi Klienta.
                    </p>
                    <router-link
                        :to="{ name: 'delivery-address' }"
                        class="a-button a-button--primary o-dashboardSummary__button o-dashboardSummary__button--emptyAddress"
                    >Złóż nowe zamówienie</router-link>
                </div>
                <div
                    v-else
                    class="l-row__column--8 o-dashboardSummary__panel o-dashboardSummary__panel--left"
                >
                    <div class="l-row">
                        <div
                            v-if="lastInvoiceStatus === 'pending'"
                            class="l-row__column"
                        >
                            <a-icon icon="Spinner" />
                        </div>
                        <div
                            v-else-if="lastInvoice"
                            class="l-row__column o-dashboardSummary__column"
                        >
                            <p class="a-title">Bieżąca płatność</p>
                            <div v-if="lastInvoice.invoice_no !== ''" class="o-dashboardSummary__content-wrapper">
                                <p class="a-text">
                                    Uprzejmie informujemy, że wystawiliśmy
                                </p>
                                <p class="a-text">
                                    FV nr
                                    <span class="a-text--bold">{{ lastInvoice.invoice_no }}</span>
                                </p>
                            </div>
                            <div v-else class="o-dashboardSummary__content-wrapper">
                                <p class="a-text">Uprzejmie informujemy, że</p>
                                <p class="a-text a-text--bold">
                                    obecnie nie ma żadnej FV do opłacenia
                                </p>
                            </div>
                            <div class="o-dashboardSummary__content-wrapper">
                                <p class="a-label a-label--big">KWOTA DO ZAPŁATY</p>
                                <p class="a-price a-price--left a-price__price">
                                    {{ lastInvoice.is_paid ? 'Faktura opłacona' : lastInvoice.gross_price.toPLN() }}
                                </p>
                            </div>
                            <div class="o-dashboardSummary__content-wrapper">
                                <router-link
                                    class="a-button o-dashboardSummary__button"
                                    :to="{ name: 'dashboard-invoices' }"
                                >
                                    Wszystkie faktury
                                    <a-icon
                                        class="a-button__icon o-dashboardSummary__icon"
                                        icon="Right"
                                    />
                                </router-link>
                            </div>
                        </div>
                        <div
                            v-if="nextDeliveryStatus === 'pending'"
                            class="l-row__column"
                        >
                                <a-icon icon="Spinner" />
                        </div>
                        <div
                            v-else-if="nextDelivery"
                            class="l-row__column o-dashboardSummary__column">
                            <p class="a-title">Najbliższa dostawa</p>
                            <div class="o-dashboardSummary__content-wrapper">
                                <p class="a-text a-text--bold">
                                    Adres najbliższej dostawy
                                </p>
                                <p class="a-text">{{ nextDelivery.address }}</p>
                            </div>
                            <div class="o-dashboardSummary__content-wrapper">
                                <p class="a-label a-label--big">Termin dostawy</p>
                                <p class="a-price a-price--left a-price__price">
                                    {{ showNextDeliveryDate() }}
                                </p>
                                <!-- <p class="a-price a-price--left">
                                    {{ showNextDeliveryDate() }}
                                </p> -->
                            </div>
                            <div class="o-dashboardSummary__content-wrapper">
                                <button
                                    v-if="!!nextDelivery.supplier && !!nextDelivery.supplier.latitude && !!nextDelivery.supplier.longitude"
                                    class="a-button o-dashboardSummary__button"
                                    @click="$store.dispatch('modalShow', {
                                        name: 'dashboardCalendarModal'
                                    })"
                                >
                                    Gdzie jest kurier
                                    <a-icon
                                        class="a-button__icon o-dashboardSummary__icon"
                                        icon="Right"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                    <!-- <hr class="a-hr m-summary__hr" />
                    <div class="l-row l-row--center">
                        <div
                            class="l-row__column o-dashboardSummary__column o-dashboardSummary__footer"
                        >
                            <a-icon class="a-icon" icon="NotificationBell" />
                            <div>
                                <p class="a-text a-text--gray">
                                    Bądź na bieżąco z fakturami i płatnościami.
                                </p>
                                <p
                                    class="a-text a-text--bold a-text--gray a-text--underline"
                                >
                                    Ustaw powiadomienia.
                                </p>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div
                    class="l-row__column--4 o-dashboardSummary__panel o-dashboardSummary__panel--right"
                >
                    <div class="l-row">
                        <div class="l-row__column o-dashboardSummary__column">
                            <p class="a-title">Masz pytania?</p>
                            <div v-if="managersStatus === 'pending'">
                                    <a-icon icon="Spinner" />
                            </div>
                            <div
                                v-else-if="managers && managers.sales_manager"
                                class="o-dashboardSummary__content-wrapper"
                            >
                                <p class="a-label a-label--big">HANDLOWIEC</p>
                                <p class="a-text a-text--bold a-text--big">
                                    {{ managers.sales_manager.full_name }}
                                </p>
                                <a
                                    :href="`tel:${managers.sales_manager.formatted_phone}`"
                                    class="a-link a-price a-price--left"
                                >
                                    {{ managers.sales_manager.formatted_phone }}
                                </a>
                            </div>
                            <hr class="a-hr m-summary__hr" />
                            <div v-if="managersStatus === 'pending'">
                                    <a-icon icon="Spinner" />
                            </div>
                            <div
                                v-else-if="managersStatus === 'empty'"
                                class="o-dashboardSummary__content-wrapper"
                            >
                                <p class="a-label a-label--big">BOK</p>
                                <a href="mailto:biuro@takeafruit.pl" class="a-link a-text a-text--big">
                                    E-mail: <strong>biuro@takeafruit.pl</strong>
                                </a>
                                <br />
                                <a href="tel:+48221105080" class="a-link a-text a-text--big">
                                    Telefon: <strong>22 110 50 80</strong>
                                </a>
                            </div>
                            <div
                                v-else-if="managers && managers.account_manager"
                                class="o-dashboardSummary__content-wrapper"
                            >
                                <p class="a-label a-label--big">BOK</p>
                                <p class="a-text a-text--bold a-text--big">
                                    {{ managers.account_manager.full_name }}
                                </p>
                                <a
                                    :href="`tel:${managers.account_manager.formatted_phone}`"
                                    class="a-link a-price a-price--left"
                                >
                                    {{ managers.account_manager.formatted_phone }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <o-modal name="dashboardCalendarModal">
            <template slot="content">
                <div
                    v-if="!!nextDelivery.supplier && !!nextDelivery.supplier.latitude && !!nextDelivery.supplier.longitude"
                    class="l-container o-dashboardCalendarModal"
                >
                    <div class="o-dashboardCalendarModal__map">
                        <p class="a-control__label a-label">
                            Gdzie jest kurier
                        </p>
                        <div class="o-dashboardCalendarModal__mapContainer">
                            <GmapMap
                                if="mapDiv"
                                class="a-control__map"
                                :center="{
                                    lat: +nextDelivery.supplier.latitude,
                                    lng: +nextDelivery.supplier.longitude
                                }"
                                :zoom="15"
                                map-type-id="terrain"
                                ref="gmap"
                            >
                                <GmapMarker
                                    :position="{
                                        lat: +nextDelivery.supplier.latitude,
                                        lng: +nextDelivery.supplier.longitude
                                    }"
                                    :draggable="false"
                                />
                            </GmapMap>
                        </div>
                    </div>
                </div>
                <div v-else >
                    <a-icon icon="Spinner" />
                </div>
            </template>
        </o-modal>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    computed: {
        lastInvoiceStatus() {
            return this.$store.getters['invoices/lastStatus']
        },
        lastInvoice() {
            return this.$store.getters['invoices/last']
        },
        nextDeliveryStatus() {
            return this.$store.getters['deliveries/nextStatus']
        },
        nextDelivery() {
            return this.$store.getters['deliveries/next']
        },
        managersStatus() {
            return this.$store.getters['companies/managersStatus']
        },
        managers() {
            return this.$store.getters['companies/managers']
        }
    },
    methods: {
        showNextDelivery() {
            return moment(this.nextDelivery.execution_date).locale('pl').fromNow()
        },
        showNextDeliveryDate() {
            return moment(this.nextDelivery.execution_date).locale('pl').format('YYYY-MM-DD')
        }
    },
    created() {
        this.$store.dispatch('invoices/fetchLast')
        this.$store.dispatch('deliveries/fetchNext')
        this.$store.dispatch('companies/fetchManagers')
        this.$store.dispatch('modalHide', 'dashboardCalendarModal')
    }
}
</script>

<style>
</style>
